import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../base/inputs/TextInput';
import TravelerFormQuestionContainer from '../../base/TravelerFormQuestionContainer';
import userId from '../../../../../shared/helpers/userId';
import { addIntakeQuestions, addAdminIntakeFormData } from '../../../actions/intakeFormActions';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
export default function IntakeAcedemicMinor(props) {
  const dispatch = useDispatch();
  const intake = useSelector(state => state.intakeForm);
  const adminIntakeFormData = intake.adminIntakeFormData;
  const { isMobile, isDesktop, isTablet } = useMediaQuery();
  const [value, setValue] = useState("");
  const [error, setError] = useState('');
  const [disabled, setDisabled] = useState(false);

  const question = {
    overline: 'Academic Minor',
    heading: 'What is your primary minor?',
    subheading: 'Enter your primary minor.',
    isRequired: intake?.intakeQuestions?.find(item=>item.identifier=="academic_minor").required ?? false,
  };

  
  useEffect(
    () => {
      if(props?.isAdmin) {
        setValue(adminIntakeFormData?.primary_minor);
      } else {
        setValue(intake.primary_minor);
      }
      
      setDisabled(intake.ssoTraveler && intake.readonly.includes('primary_minor'));
    },
    [intake, adminIntakeFormData],
  );

  const handleNext = () => {
    
    setError("");
    if (!disabled && !value && question.isRequired) {
      setTimeout(()=>{
        setError('Required, please enter your primary minor');
      },0) 
      if(props.isAdmin) {
        return;
      }
      throw new Error();
    }
    if(props.isAdmin) {
      dispatch(addAdminIntakeFormData( "primary_minor", value));
      props.handleAdminStep();
      return;
    }
    if (!disabled) {
       dispatch(addIntakeQuestions(userId, { primary_minor: value }, "primary_minor"));
    }
  };

  const customInputStyle = {
    display: "flex",
    padding: "6px 12px",
    alignItems: "center",
    flex: "1 0 0",
    borderRadius: "4px",
    border: "1px solid var(--Gray-400, #CED4DA)",
    background: disabled ? "#eeeeee" : "var(--Gray-White, #FFF)",
  }
  const customInputContainerStyle = {
    width : isDesktop ? "100%" : "100%",
    marginTop:"1.375rem",
  }

  return (
    <TravelerFormQuestionContainer 
      isAdmin={props.isAdmin} 
      question={question} 
      handleBackStep={()=>props.handleAdminBackStep()} 
      handleNext={handleNext} 
      adminIntakeStep={props.adminIntakeStep}
      disabled={disabled} canBeSynced>
      <TextInput
        value={value}
        id="academic_minor"
        label="Minor - Primary"
        placeholder="Enter primary minor"
        error={error}
        disabled={disabled}
        required={question.isRequired}
        handleOnChange={event => {
          setValue(event.target.value);
        }}
        customInputStyle = {customInputStyle}
        customInputContainerStyle = {customInputContainerStyle}
      />
    </TravelerFormQuestionContainer>
  );
}
